// layouts/ParentLayout.js
import ParentSidebar from "../components/parent/ParentSidebar";
// import ParentBottomNav from "../components/parent/ParentBottomNav"; // optional
import { Outlet, useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import React, { useEffect } from "react";
import { useLayout } from "../contexts/LayoutContext";

export default function ParentLayout() {
  const navigate = useNavigate();
  const handleLogout = async () => {
    await auth.signOut();
    navigate("/login");
  };

  const { setIsFullWidth } = useLayout();
    useEffect(() => {
      setIsFullWidth(true);
      return () => setIsFullWidth(false);
    }, [setIsFullWidth]);

  return (
    <div className="role-theme-surface flex min-h-screen bg-bg text-text relative">
      <ParentSidebar onLogout={handleLogout} />
      <div className="flex-1 min-h-screen p-4 md:ml-0 pb-16">
        <div className="mx-auto max-w-5xl">
          <Outlet />
        </div>
      </div>
      {/* <ParentBottomNav /> */}
    </div>
  );
}
